module.exports = __webpack_public_path__ + "loadingcincel.svg?2e23eb2cef949f991debd479ca7c918c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loadingcincel.svg
// module id = 2208
// module chunks = 2